<template>
  <section>
    <div class="row">
      <!-- Action Buttons -->
      <div class="col-md-5"></div>
      <!-- Pagination -->
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-5">
            <nav>
              <z-paginate
                v-model="page"
                :page-count="pages"
                @change="changePage"
              />
            </nav>
          </div>
          <div class="col-md-5"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZSearch from '../ZElements/Search'
import ZSelect from '../ZElements/Select'
import ZPaginate from '../ZElements/Paginate'
export default {
  name: 'feed-footer',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate,
  },
  emits: ['search'],
  computed: {
    ...mapGetters('feed', ['pager']),
    pages() {
      let _pages = 1
      if (this.pager) {
        _pages = this.pager.pages ? this.pager.pages : 1
      }
      return _pages
    },
    page: {
      get() {
        let _page = 1
        if (this.pager) {
          _page = this.pager.page ? this.pager.page : 1
        }
        return _page
      },
      set(value) {
        this.setPager({
          name: 'page',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('feed', ['setPager']),
    changePage() {
      this.$emit('search')
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
